module.exports = __webpack_public_path__ + "static/media/desktop.aec71c16.png";